// Lib
import { createAction } from 'redux-actions';

export interface AIPromptRequest {
  id: string;
  prompt: string;
}

let fallbackRequestSequence = 0;

const createPromptRequestId = (): string => {
  if (typeof globalThis.crypto?.randomUUID === 'function') {
    return globalThis.crypto.randomUUID();
  }
  fallbackRequestSequence += 1;
  return `${Date.now().toString(36)}-${fallbackRequestSequence.toString(36)}`;
};

/**
 * Asks the AI panel to open a fresh conversation on this prompt.
 *
 * The panel sends it through its own `onSendMessage`, which is what raises the
 * in-flight state (optimistic echo + thinking indicator). Minting the session
 * outside and handing over the id instead looked equivalent but was not: the
 * panel adopted a session it believed to be idle — `onSetSession` resets
 * `loadingSubscription` and marks the session COMPLETED — so the turn ran with
 * no indicator at all, behind an extra mutation round-trip.
 */
export const RequestAIPrompt = createAction<AIPromptRequest, string>(
  'REQUEST_AI_PROMPT',
  (prompt) => ({ id: createPromptRequestId(), prompt }),
);

/** Cleared by the panel once it has taken the request. */
export const ClearAIPromptRequest = createAction('CLEAR_AI_PROMPT_REQUEST');
